export default {
    buscando: false,
    items: [],
    tratativas_opcoes: [],
    selecionado: {}
}